import React, { Component, useEffect, useState } from "react";
import "./ViewPayment.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetPaymentDetailsDTO from "../../../models/DTO/IGetPaymentDetailsDTO";
import IOnGetPaymentDetailsDTO from "../../../models/DTO/IOnGetPaymentDetailsDTO";
import IVoidAChargeDTO from "../../../models/DTO/IVoidAChargeDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOrder from "../../../models/IOrder";
import IPayment from "../../../models/IPayment";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import UserService from "../../../services/UserService";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    orderModel: IOrder;
    payment: IPayment;
};

export const ViewPayment: React.FC<Props> = (props) => {
    const [payment, setPayment] = useState<IPayment | undefined>();
    const [confirmVoidPayment, setConfirmVoidPayment] = useState<boolean>(false);
    const [voidPaymentActive, setVoidPaymentActive] = useState<boolean>(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.PaymentsOnGetPaymentDetails, onGetPaymentDetails);
        props.socket.on(EndpointsEnum.Notify, notify);

        getPaymentDetails();

        return () => {
            props.socket.removeListener(EndpointsEnum.PaymentsOnGetPaymentDetails, onGetPaymentDetails);
            props.socket.removeListener(EndpointsEnum.Notify, notify);
        };
    }, []);

    const notify = (data: IErrorDTO) => {
        if (data.message === "ERROR_VOID_CHARGE") {
            setVoidPaymentActive(false);
        }
    };

    const getPaymentDetails = () => {
        const payload: IGetPaymentDetailsDTO = {
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            paymentGuid: props.payment.guid,
        };

        props.socket.emit(EndpointsEnum.PaymentsGetPaymentDetails, payload);
    };

    const onGetPaymentDetails = (data: IOnGetPaymentDetailsDTO) => {
        setPayment(data.paymentModel);
    };

    const closeModal = () => {
        props.closeModalFn();
    };

    const processCaptureDetail = (payment: IPayment) => {
        const captureDetail = JSON.parse(payment.capture_detail || "");

        const amount = captureDetail.amount;
        const currency = captureDetail.currency;
        const number = captureDetail.card.number;
        const name = captureDetail.card.name;
        const cardType = captureDetail.card.cardType;

        const currencySymbol = "$";

        return (
            <div>
                <div>
                    {currencySymbol}
                    {amount}
                </div>
                <div>{number}</div>
                <div>{cardType}</div>
                <div>{name}</div>
                <div className={"mt-3"}>ID: {captureDetail.id}</div>
                <div>Auth ID: {payment.auth_id}</div>
            </div>
        );
    };

    const create = () => {};

    const voidPayment = () => {
        setConfirmVoidPayment(true);
    };

    const issueRefund = () => {};

    const cancelVoidPayment = () => {
        setConfirmVoidPayment(false);
    };

    const confirmAndVoidPayment = () => {
        setVoidPaymentActive(true);

        voidCharge();
    };

    const voidCharge = () => {
        if (payment) {
            const payload: IVoidAChargeDTO = {
                userGuid: props.userModel.guid,
                userToken: props.userModel.token,
                supplierGuid: props.supplierModel.guid,
                paymentGuid: payment.guid,
            };

            props.socket.emit(EndpointsEnum.PaymentsVoidCharge, payload);
        }
    };

    const onVoidACharge = (data: any) => {
        setVoidPaymentActive(false);
    };

    return (
        <div className={"ViewPayment p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-credit-card"} title={"view_payment"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                {payment && !confirmVoidPayment ? (
                    <div>
                        <div>{props.orderModel.name}</div>
                        <div>{processCaptureDetail(payment)}</div>
                        <div>{UserService.parseLastUpdated(payment.created_at, true)}</div>
                        {/*<div className={"mt-3"}>*/}
                        {/*    <OwButton title={'void_payment'} fn={voidPayment} className={"btn btn-danger me-2"}/>*/}
                        {/*    <OwButton title={'issue_refund'} fn={issueRefund}/>*/}
                        {/*</div>*/}
                    </div>
                ) : null}
                {payment && confirmVoidPayment ? (
                    <div>
                        <div className={"mt-3 mb-3"}>
                            <OwLabel className={"text-danger"} title={"confirm_void_payment"} isBold={true} />
                        </div>
                        <div>{props.orderModel.name}</div>
                        <div>{processCaptureDetail(payment)}</div>
                        <div className={"mt-3"}>
                            <OwButton
                                title={"confirm_and_void"}
                                fn={confirmAndVoidPayment}
                                active={voidPaymentActive}
                                disableOnActive={true}
                                className={"me-2 btn btn-danger"}
                            />
                            <OwButton title={"cancel"} fn={cancelVoidPayment} />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
